import { useState } from 'react';
import { allow } from '../classes/allow';
import local from '../classes/local';
import getSite from '../functions/get.site';
import is from '../objects/is';
import useTrait from './use.trait';

export default function useGlobal() {
    const [site, setSite] = useState(getSite());
    const showAccountIsUnlockedAlert = useTrait(false);
    const showNewAccountLoginAlert = useTrait(false);
   
    const updateSite = (siteName = '') => {
        allow.aString(siteName, is.not.empty);
        local.setItem('site', siteName);
        setSite(siteName);
    };
   
    return {
        site,
        showAccountIsUnlockedAlert,
        showNewAccountLoginAlert,
        updateSite,
    };
}